import
  React 
from 'react';

import 
  styled 
from 'styled-components';

import { 
  Button
} from './Button';

export const RedButton = styled((props) => <Button {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_Button_${props?.automationidattr?.replace(/ /g, '')}_1"`,
  })
)`
  border-radius: ${(props) => (props.borderRadius)};
  padding: ${(props) => (props.padding)};
  border: solid 1px #e60000;
  color: white;
  background: #e60000;
  &:hover {
    background: #a60000;
  }
  &:disabled {
    background: #ebebeb;
    color: #cccccc;
    border: none;
  }
`;
